import React, { Fragment, useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarProductosConfiguracion, filtarProductosConfiguracion, obtenerCodigoSiguienteProducto } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

import FiltrosProducto from './FiltrosProducto';
import NuevoProducto from './NuevoProducto';
import EditarProducto from './EditarProducto';
import DetallesProducto from './DetallesProducto';
import EliminarProducto from './EliminarProducto';
import EliminarProductos from './EliminarProductos';
import EditarProductos from './EditarProductos';
import ProveedoresProducto from './ProveedoresProducto';

const Productos = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Productos',
            path: '/configuracion/productos'
        }
    ];

    const dispatch = useDispatch();
    const { listado } = useSelector(state => state.configuracion.productos);

    const [productos, setProductos] = useState([]);
    const [productosEliminar, setProductosEliminar] = useState([]);

    const [productoAgregar, setProductoAgregar] = useState(null);
    const [productoEditar, setProductoEditar] = useState(null);
    const [productoDetalles, setProductoDetalles] = useState(null);
    const [productoEliminar, setProductoEliminar] = useState(null);
    const [multipleEliminar, setMultipleEliminar] = useState(null);
    const [multipleEditar, setMultipleEditar] = useState(null);

    const [productoProveedores, setProductoProveedores] = useState(null);

    const [busqueda, setBusqueda] = useState('');

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const handleCheckbox = ({ target }) => {
        const productoId = target.id.split('-')[1];

        setProductosEliminar(prevState => {
            if (target.checked) {
                return [...prevState, productoId];
            } else {
                return prevState.filter(id => id !== productoId);
            }
        });
    };

    const columns = [
        {
            name: '',
            width: '60px',
            cell: row => {
                return (
                    <div className="form-check" key={'producto-' + row._id}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={'producto-' + row._id}
                            onChange={handleCheckbox}
                            checked={productosEliminar.includes(row._id + '')}
                        />
                    </div>
                );
            }
        },
        {
            name: 'Código',
            selector: row => row.codigo_tienda,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.nombre,
            wrap: true,
            grow: 2,
            sortable: true,
        },
        {
            name: 'Descripción',
            selector: row => row?.descripcion || 'Sin definir',
            wrap: true,
        },
        {
            name: 'Categoría',
            selector: row => row.categoria?.nombre || 'Sin definir',
            wrap: true,
        },
        {
            name: 'Subcategoría',
            selector: row => row.subcategoria?.nombre || 'Sin definir',
            wrap: true,
        },
        {
            name: '',
            width: '150px',
            button: true,
            ignoreRowClick: true,
            allowOverflow: true,
            cell: row => {
                return (
                    <div className="d-flex justify-content-end align-items-center gap-2 w-100">
                        <button
                            type="button"
                            className="btn btn-sm btn-link p-0"
                            onClick={() => handleProveedoresProducto(row)}
                            title="Ver proveedores"
                        >
                            <i className="fas fa-truck text-info"></i>
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-link p-0"
                            onClick={() => handleEditarProducto(row)}
                            title="Editar"
                        >
                            <i className="fas fa-edit text-warning"></i>
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-link p-0"
                            onClick={() => handleEliminarProducto(row)}
                            title="Eliminar"
                        >
                            <i className="fas fa-trash text-danger"></i>
                        </button>
                    </div>
                );
            }
        }
    ];

    const handleFiltrosBusqueda = () => {
        dispatch(filtarProductosConfiguracion(true));
    };

    const handleAgregarProducto = (producto) => {
        setProductoEditar(null);
        setProductoDetalles(null);
        setProductoEliminar(null);
        setMultipleEliminar(null);
        setMultipleEditar(null);

        setProductoAgregar(producto);
    };

    const handleAbrirNuevoProducto = async () => {
        await dispatch(obtenerCodigoSiguienteProducto());
        setProductoAgregar({});
    };

    const handleEditarProducto = (producto) => {
        setProductoAgregar(null);
        setProductoDetalles(null);
        setProductoEliminar(null);
        setMultipleEliminar(null);
        setMultipleEditar(null);

        setProductoEditar(producto);
    };

    const handleDetallesProducto = (producto) => {
        setProductoAgregar(null);
        setProductoEditar(null);
        setProductoEliminar(null);
        setMultipleEliminar(null);
        setMultipleEditar(null);

        setProductoDetalles(producto);
    };

    const handleEliminarProducto = (producto) => {
        setProductoAgregar(null);
        setProductoDetalles(null);
        setProductoEditar(null);
        setMultipleEliminar(null);
        setMultipleEditar(null);

        setProductoEliminar(producto);
    };

    const handleEditarProductosMultiples = (productosIds) => {
        setProductoAgregar(null);
        setProductoDetalles(null);
        setProductoEditar(null);
        setProductoEliminar(null);
        setMultipleEliminar(null);

        setMultipleEditar(productosIds);
    };

    const handleReestablecerEditarMultiple = () => {
        setMultipleEditar(null);
        setProductosEliminar([]);
    };

    const handleEliminarProductos = (productosIds) => {
        setProductoAgregar(null);
        setProductoDetalles(null);
        setProductoEditar(null);
        setProductoEliminar(null);

        setMultipleEliminar(productosIds);

        if (productosIds?.length === 0) {
            setProductosEliminar([]);
        }
    };

    const handleLimpiarBusqueda = () => {
        setBusqueda('');
    };

    const handleProveedoresProducto = (producto) => {
        setProductoAgregar(null);
        setProductoDetalles(null);
        setProductoEditar(null);
        setProductoEliminar(null);
        setMultipleEliminar(null);
        setMultipleEditar(null);

        setProductoProveedores(producto);
    };

    const productosFiltrados = useMemo(() => {
        const texto = (busqueda || '').toString().toLowerCase().trim();
        if (!texto) return productos;

        return productos.filter(p => {
            const campos = [
                p.codigo_tienda,
                p.codigo,
                p.nombre,
                p.descripcion,
                p.categoria?.nombre,
                p.subcategoria?.nombre,
            ];

            return campos.some(campo =>
                (campo ?? '').toString().toLowerCase().includes(texto)
            );
        });
    }, [productos, busqueda]);

    useEffect(() => {
        dispatch(buscarProductosConfiguracion({
            nombre: null,
            categoria: null,
            subcategoria: null,
            subsubcategoria: null,
            codigo_barras: null
        }));
    }, []);

    useEffect(() => {
        setProductos(listado || []);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <FiltrosProducto />
            <NuevoProducto producto={productoAgregar} reestablecerProducto={handleAgregarProducto} />
            <EditarProducto producto={productoEditar} reestablecerProducto={handleEditarProducto} />
            <DetallesProducto producto={productoDetalles} reestablecerProducto={handleDetallesProducto} />
            <EliminarProducto producto={productoEliminar} reestablecerProducto={handleEliminarProducto} />
            <EliminarProductos productos={multipleEliminar} reestablecerProductos={handleEliminarProductos} />
            <EditarProductos productos={multipleEditar} reestablecerProductos={handleReestablecerEditarMultiple} />
            <ProveedoresProducto producto={productoProveedores} reestablecerProducto={handleProveedoresProducto} />

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Productos</h3>

                    <div className="d-flex flex-wrap align-items-center mb-3 gap-2">
                        {productosEliminar.length > 0 && (
                            <div className="d-flex flex-wrap align-items-center gap-2">
                                <button
                                    type="button"
                                    className="btn btn-warning"
                                    onClick={() => handleEditarProductosMultiples(productosEliminar)}
                                >
                                    Editar {productosEliminar.length} producto{productosEliminar.length === 1 ? '' : 's'}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => handleEliminarProductos(productosEliminar)}
                                >
                                    Eliminar {productosEliminar.length} producto{productosEliminar.length === 1 ? '' : 's'}
                                </button>
                            </div>
                        )}

                        <div className="d-flex flex-wrap align-items-center gap-2 ms-auto justify-content-end" style={{ width: '100%' }}>
                            <div className="position-relative" style={{ maxWidth: '320px', width: '100%' }}>
                                <input
                                    type="text"
                                    className="form-control pe-5"
                                    placeholder="Buscar por código, nombre, categoría..."
                                    value={busqueda}
                                    onChange={e => setBusqueda(e.target.value)}
                                />
                                {busqueda && (
                                    <button
                                        type="button"
                                        className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0"
                                        onClick={handleLimpiarBusqueda}
                                        title="Limpiar búsqueda"
                                        aria-label="Limpiar búsqueda"
                                    >
                                        <i className="fas fa-times text-muted"></i>
                                    </button>
                                )}
                            </div>

                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={handleFiltrosBusqueda}
                            >
                                Filtros avanzados
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAbrirNuevoProducto}
                            >
                                Agregar producto
                            </button>
                        </div>
                    </div>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={productosFiltrados}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover
                            persistTableHead
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Productos;